import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch} from 'react-router-dom';
import axios from 'axios';
import Login from './pages/auth/Login';
import setAuthToken from './utils/setAuthToken';
import { logoutUser } from './api/web';
import Private from "./components/routes/Private";
import Logout from "./pages/auth/Logout";
import { Provider } from 'react-redux';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap';

import store from './stores';

let isLoggingOut = false;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const isLoginRequest = requestUrl.includes('/admin/login/');

    if (status === 401 && !isLoginRequest && !isLoggingOut) {
      isLoggingOut = true;
      toast.error('Session expired or unauthorized. Please log in again.', {
        position: 'top-right',
        autoClose: 3000
      });
      store.dispatch(logoutUser());
      window.location.href = '/';
    }

    return Promise.reject(error);
  }
);

//Check for token
if(localStorage.jwtToken) {
  //Set auth token header auth
  setAuthToken(localStorage.jwtToken);

  const {auth} =  store.getState();

  if(auth.user.user.expiry < new Date()) {
    //Logout user
    store.dispatch(logoutUser());
    //Clear current profile
    window.location.href = "/";
  }
}

class App extends Component {
  render() {
    return (
        <Provider store={ store }>
          <Router>
            <div className="App">
              <Switch>
                <Route exact path="/" component={Login} />
                <Route exact path="/logout" component={Logout} />
                <Route component={Private} />
              </Switch>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </div>
          </Router>
        </Provider>
    );
  }
}

export default App;
